<template>
  <div id="student-info">
    <h2 class="px-4 text-xl font-semibold sm:px-0 hidden">Student Info</h2>
    <div class="table-container sm:border sm:rounded" v-if="!loading">
      <table class="w-full">
        <tbody>
          <tr>
            <th scope="row">
              Name
            </th>
            <td>
              <span v-if="loading"> Loading...</span>
              <span v-else>
                {{ fullName }}
              </span>
            </td>
          </tr>
          <tr>
            <th scope="row">
              Email
            </th>
            <td>
              <span v-if="loading"> Loading...</span>
              <span v-else>
                {{ studentData.email }}
              </span>
            </td>
          </tr>
          <tr v-if="studentData.major">
            <th scope="row">
              Major
            </th>
            <td>
              <span v-if="loading"> Loading...</span>
              <span v-else>
                {{ studentData.major }}
              </span>
            </td>
          </tr>
          <tr v-if="formioData.major">
            <th scope="row">
              Major
            </th>
            <td>
              <span v-if="loading"> Loading...</span>
              <span v-else>
                {{ formioData.major }}
              </span>
            </td>
          </tr>
          <tr v-if="formioData.minor">
            <th scope="row">
              Minor
            </th>
            <td>
              <span v-if="loading"> Loading...</span>
              <span v-else>
                {{ formioData.minor }}
              </span>
            </td>
          </tr>
          <tr v-if="confirmed.includes(tab)">
            <th scope="row">
              Confirmed
            </th>
            <td>
              <span v-if="loading"> Loading...</span>
              <span v-else>
                {{ tabApplication.confirmed }}
              </span>
            </td>
          </tr>
          <tr v-if="programType.includes(tab) && tabApplication.programType">
            <th scope="row">
              Program Type Interested In
            </th>
            <td>
              <span v-if="loading"> Loading...</span>
              <span v-else>
                {{ tabApplication.programType }}
              </span>
            </td>
          </tr>

          <tr v-if="formioData.gpa">
            <th scope="row">
              GPA
            </th>
            <td>
              <span v-if="loading"> Loading...</span>
              <span v-else>
                {{ formioData.gpa }}
              </span>
            </td>
          </tr>

          <tr v-if="tab !== 'application' && tabApplication.finalcialAid">
            <th scope="row">
              Finalcial Aid
            </th>
            <td>
              <span v-if="loading">Loading...</span>
              <span v-else>
                {{ tabApplication.finalcialAid }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "student-info",
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: true
    },
    studentData: {
      type: Object,
      default: function() {
        return {};
      },
      required: true
    },
    fullName: {
      type: String,
      default: ""
    },
    tab: {
      type: String,
      default: "",
      required: true
    },
    tabApplication: {
      type: Object,
      default() {
        return {
          programSessionId: "",
          applicationId: "",
          confirmed: "",
          finalcialAid: "",
          programType: ""
        };
      }
    }
  },
  data() {
    return {
      formioData: {
        gpa: "",
        minor: "",
        major: ""
      },
      confirmed: ["accepted", "all"],
      programType: ["application", "all"]
    };
  },
  mounted() {
    this.getFormioData();
  },
  methods: {
    getFormioData() {
      fetch(
        process.env.VUE_APP_FORMIO_URL +
          "/studentapplicationstage2step1/submission/?data.application_id=" +
          this.tabApplication.applicationId,
        {
          headers: {
            "Content-type": "application/json",
            "x-jwt-token": this.$store.state.advisor.token
          },
          method: "GET"
        }
      )
        .then(response => response.json())
        .then(data => {
          const formdata = data[0].data;
          this.formioData = {
            gpa: formdata.gpa,
            minor: formdata.minor.name,
            major: formdata.secondMajor.name
          };
        })
        .catch(error => {
          console.log("Error something went wrong: " + error);
        });
    }
  }
};
</script>

<style lang="postcss" scoped>
.table-container {
  @apply px-3 mt-3;
  @apply bg-white border-t border-b border-gray-300;
}
th {
  @apply py-3;
  @apply text-xs tracking-widest text-left text-gray-500 uppercase;
}
td {
  @apply py-3;
  @apply text-right;
}
</style>
